var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5208 4.11203L7.55438 4.66567L6.99479 4.59788C4.95791 4.33801 3.17843 3.45671 1.66756 1.97658L0.928908 1.24216L0.73865 1.7845C0.33575 2.99346 0.593158 4.27021 1.43253 5.12891C1.8802 5.60346 1.77948 5.67125 1.00725 5.38878C0.73865 5.2984 0.503625 5.2306 0.481242 5.2645C0.4029 5.34359 0.6715 6.37177 0.884142 6.77852C1.17513 7.34346 1.76828 7.8971 2.4174 8.22476L2.96579 8.48463L2.31668 8.49593C1.68994 8.49593 1.66756 8.50723 1.73471 8.7445C1.95854 9.47891 2.84268 10.2585 3.82755 10.5975L4.52143 10.8348L3.91708 11.1963C3.02175 11.7161 1.96973 12.0098 0.917717 12.0324C0.414092 12.0437 0 12.0889 0 12.1228C0 12.2358 1.36538 12.8685 2.15999 13.1171C4.54382 13.8515 7.37531 13.5351 9.50173 12.281C11.0126 11.3884 12.5235 9.6145 13.2286 7.8971C13.6091 6.9819 13.9896 5.30969 13.9896 4.50749C13.9896 3.98775 14.0232 3.91995 14.6499 3.29853C15.0192 2.93697 15.3662 2.54151 15.4333 2.42853C15.5452 2.21385 15.534 2.21385 14.9633 2.40593C14.012 2.74489 13.8777 2.69969 14.3477 2.19125C14.6947 1.8297 15.1088 1.17437 15.1088 0.982293C15.1088 0.948397 14.9409 1.00489 14.7506 1.10658C14.5492 1.21957 14.1015 1.38905 13.7658 1.49073L13.1614 1.68281L12.613 1.30996C12.3108 1.10658 11.8856 0.880605 11.6617 0.812812C11.0909 0.654631 10.218 0.677228 9.70318 0.858007C8.30422 1.36645 7.42008 2.6771 7.5208 4.11203Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cc69ae4256463bdd677cd4e63fd18ea5.svg";
export { ForwardRef as ReactComponent };